import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import NotificationStats from "../../../../containers/NotificationStats";
import NotificationsList from "../../../../containers/NotificationsList";
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import Api from "../../../../services/Api";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  async componentDidMount() {
    await this.fetchStatus();
  }
  fetchStatus = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/stat', null, {
        params: {
          category: 'EVENT',
        },
      });
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  render() {
    const {match, history} = this.props;
    const {status} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <div className="mb-4">
                  <NotificationStats data={status}/>
                </div>
                <NotificationsList category="EVENT" history={history}/>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default List;
